<template>
  <div>
    <radio-list
      :label="question.label"
      :helptext="question.helpText"
      :collapsibleContent="question.content"
      :tooltip="question.tooltip"
      :isActiveTooltip="isActiveTooltip"
      :options="question.options"
      :value="value"
      v-on:change="emitInput"
      @toggleTooltip="toggleTooltip"
    />
    <bordered-content v-if="cmsText">
      <div v-html="cmsText"></div>
      <div v-if="liveChat || externalLink">
        <button type="button" class="c-button c-button--brand" v-if="liveChat">
          Live Chat
        </button>
        <a
          class="c-button c-button--brand"
          v-bind:href="externalLinkUrl"
          v-if="externalLink"
        >
          {{ externalLinkText }}
        </a>
      </div>
    </bordered-content>
  </div>
</template>

<script>
  import RadioList from "../../forms/radio-list/RadioList.vue";
  import BorderedContent from "./BorderedContent.vue";
  export default {
    components: {
      RadioList,
      BorderedContent,
    },
    props: {
      index: {
        required: true,
        type: Number,
      },
      question: {
        required: true,
        type: Object,
      },
      activeTooltipId: {
        type: String,
      },
    },
    data() {
      return {
        cmsText: null,
        externalLink: null,
        externalLinkText: null,
        externalLinkUrl: null,
        liveChat: null,
        value: this.question.answer,
      };
    },
    destroyed() {
      this.value = "";
      this.question.answer = "";
      this.question.answerLabel = "";
    },
    watch: {
    'question.answerLabel'(newVal) {
      if (newVal === '') {
        this.value = this.question.answerLabel;
      }
    },
  },
    computed: {
      isActiveTooltip() {
        return this.activeTooltipId === this.question.label;
      },
    },
    methods: {
      toggleTooltip(value) {
        this.$emit("activeTooltip", value ? this.question.label : "");
      },
      emitInput(optionIndex, option) {
        if (this.value !== option.value) {
          this.value = option.value;
          this.cmsText = this.question.options[optionIndex].text;
          this.externalLink =
            this.question.options[optionIndex].linkText &&
            this.question.options[optionIndex].linkUrl;
          this.externalLinkText = this.question.options[optionIndex].linkText;
          this.externalLinkUrl = this.question.options[optionIndex].linkUrl;
          this.liveChat = this.question.options[optionIndex].chat;

          this.$emit(
            "input",
            this.value,
            this.index,
            this.question.id,
            option.nextId,
            option.final,
            option.upload
          );
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/_contact-us-rap/_vue/RadioListOptions.vue